import { getUrl, sessionExpired } from "../setEnvironment";

class WorkstationsAPI {
  constructor() {
    this.URL = getUrl();
    this.newWorkstation = this.newWorkstation.bind(this);
    this.getAllWS = this.getAllWS.bind(this);
    this.deleteWorkstation = this.deleteWorkstation.bind(this);
    this.updateWorkstation = this.updateWorkstation.bind(this);
    this.cancelAllTasksWorkstation = this.cancelAllTasksWorkstation.bind(this);
    this.checkWSPositions = this.checkWSPositions.bind(this);
    this.getNullWSPositions = this.getNullWSPositions.bind(this);
    this.blockWorkstation = this.blockWorkstation.bind(this);
    this.unBlockWorkstation = this.unBlockWorkstation.bind(this);
    this.lockWSPosition = this.lockWSPosition.bind(this);
    this.unlockWSPosition = this.unlockWSPosition.bind(this);
    this.updateCheckWork = this.updateCheckWork.bind(this);
    this.getWSPositions = this.getWSPositions.bind(this);
    this.strictPriorityWorkstation = this.strictPriorityWorkstation.bind(this);
    this.unstrictPriorityWorkstation = this.unstrictPriorityWorkstation.bind(this);
    this.updateWorkStatusWorkstation = this.updateWorkStatusWorkstation.bind(this);
    this.addQueues = this.addQueues.bind(this);
    this.addRotationPosition = this.addRotationPosition.bind(this);
    this.updateFacesValues = this.updateFacesValues.bind(this);
    this.getPositionsStatus = this.getPositionsStatus.bind(this);
  }
  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión, ya no se
  // envía como parámetro (createdBy) — quien crea la estación es siempre quien está autenticado.
  async newWorkstation(
    wsname,
    wstime,
    wstype,
    wsbuffer,
    wsmaxtasks,
    inboundArea,
    strategyInbound,
    positions,
    token
  ) {
    try {
      const response = await fetch(this.URL + "/workstation/createWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: wsname,
          timepicking: wstime,
          type: wstype,
          wsBuffer: wsbuffer,
          maxTasks: wsmaxtasks,
          inboundArea: inboundArea,
          strategyInbound: strategyInbound,
          positions: positions,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión —
  // createdBy tampoco se envía: el backend ya no lo actualiza (ver nota en el propio
  // repositorio), es quién creó la estación originalmente, no algo editable.
  async updateWorkstation(
    wsname,
    new_wsname,
    time,
    type,
    wsBuffer,
    maxTasks,
    inboundArea,
    strategyInbound,
    outsideConfirmation,
    positions,
    token
  ) {
    let body = {
      name: wsname,
      new_name: new_wsname,
      new_timepicking: time,
      new_type: type,
      new_wsBuffer: wsBuffer,
      new_maxTasks: maxTasks,
      new_inboundArea: inboundArea,
      new_strategyInbound: strategyInbound,
      new_outsideConfirmation: outsideConfirmation,
      new_positions: positions,
    };
    try {
      const response = await fetch(this.URL + "/workstation/modifyWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (response.status >= 200 && response.status < 300) {
        return json;
      } else {
        throw json;
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async deleteWorkstation(wsname, token) {
    try {
      const response = await fetch(this.URL + "/workstation/deleteWorkStation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: wsname,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }
  async getNullWSPositions(token) {
    try {
      const response = await fetch(this.URL + "/workstation/getWsPositionNull", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async getWSPositions(token) {
    try {
      const response = await fetch(this.URL + "/workstation/getWSposition", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async checkWSPositions(token) {
    try {
      const response = await fetch(this.URL + "/workstation/checkWsPosition", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();

      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async lockWSPosition(wspos, token) {
    try {
      const response = await fetch(this.URL + "/workstation/lockWSPosition", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ws_pos: wspos,
        }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
  async unlockWSPosition(wspos, token) {
    try {
      const response = await fetch(this.URL + "/workstation/unlockWSPosition", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ws_pos: wspos,
        }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async blockWorkstation(wsname, token) {
    try {
      const response = await fetch(this.URL + "/workstation/lockWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          sgpWS: wsname,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;

      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async unBlockWorkstation(wsname, token) {
    try {
      const response = await fetch(this.URL + "/workstation/unlockWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          sgpWS: wsname,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;

      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async updateCheckWork(ws_pos, value, token) {
    try {
      const response = await fetch(this.URL + "/workstation/updateCheckWork", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ws_pos: ws_pos,
          value: value,
        }),
      }).catch(function (e) {
        console.log("ERROR", e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;

      return json;
    } catch (e) {
      console.log("ERROR__", e);
      throw e;
    }
  }

  async cancelAllTasksWorkstation(wsname, token) {
    console.log(wsname);
    console.log(token);
    try {
      const response = await fetch(this.URL + "/processingtask/endAllTasksByTps", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          workstation: wsname,
        }),
      }).catch(function (e) {
        console.log("ERROR", e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;

      return json;
    } catch (e) {
      console.log("ERROR__", e);
      throw e;
    }
  }

  // P01021-137: el backend ya resolvía esto correctamente desde el token, username nunca se
  // llegó a usar realmente.
  async getAllWS(token) {
    try {
      const response = await fetch(this.URL + "/workstation/getAllWS", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async strictPriorityWorkstation(wsname, token) {
    try {
      console.log("api");
      const response = await fetch(this.URL + "/workstation/strictPriorityWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          sgpWS: wsname,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;

      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async unstrictPriorityWorkstation(wsname, token) {
    try {
      const response = await fetch(this.URL + "/workstation/unstrictPriorityWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          sgpWS: wsname,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;

      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async updateWorkStatusWorkstation(workstation, isClosed, token) {
    try {
      const response = await fetch(this.URL + "/workstation/updateWorkStatusWorkstation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          workstation: workstation,
          isClosed: isClosed,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = response;
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async addQueues(ws_pos, queue_init, queue_end, confirmation_point, token) {
    try {
      const response = await fetch(this.URL + "/workstation/addQueues", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ws_pos,
          queue_init,
          queue_end,
          confirmation_point,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-142: punto de rotación por posición, no por estación (sustituye a addRotation).
  async addRotationPosition(ws_pos, rotation_point, token) {
    try {
      const response = await fetch(this.URL + "/workstation/addRotationPosition", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ws_pos,
          rotation_point,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async updateFacesValues(ws_pos, face_values, token) {
    try {
      console.log("updateFacesValues", ws_pos, face_values);

      // Asegúrate de que face_values sea un objeto
      const body = {
        ws_pos,
        face_values: typeof face_values === "string" ? JSON.parse(face_values) : face_values,
      };

      const response = await fetch(this.URL + "/workstation/updateFaceValues", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body), // Convierte el cuerpo a JSON
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-139 (Fase 2): widget "Estado de posiciones" del Dashboard.
  async getPositionsStatus(token) {
    try {
      const response = await fetch(this.URL + "/workstation/positionsStatus", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }
}

let _workstationsAPI = null;

const initWorkstationsAPI = () => {
  if (!_workstationsAPI) {
    _workstationsAPI = new WorkstationsAPI();
  }
  return _workstationsAPI;
};

const getWorkstationsAPI = () => {
  return initWorkstationsAPI();
};

export { initWorkstationsAPI, getWorkstationsAPI };
